<p-select
  class="language-flag-select"
  [ngModel]="selectedValue"
  [options]="languages"
  optionLabel="label"
  optionValue="value"
  [showClear]="false"
  [filter]="false"
  appendTo="body"
  [overlayOptions]="{ autoZIndex: true }"
  (ngModelChange)="onValueChange($event)"
>
  <ng-template let-option pTemplate="selectedItem">
    <img
      *ngIf="option?.flag"
      class="language-flag-select__flag"
      [src]="getFlagPath(option)"
      [alt]="option.label"
    />
  </ng-template>
  <ng-template let-option pTemplate="item">
    <div class="language-flag-select__item">
      <img
        *ngIf="option?.flag"
        class="language-flag-select__flag"
        [src]="getFlagPath(option)"
        [alt]="option.label"
      />
    </div>
  </ng-template>
</p-select>
